 const validateAddress = (address) => {
  if (!address.address1?.trim()) {
    return 'userCard.address.error';
  }
  if (!address.city?.trim()) {
    return 'userCard.city.error';
  }
  if (!address.state) {
    return 'userCard.state.error';
  }
  if (!address.zipcode?.trim()) {
    return 'userCard.zipcode.error';
  }
  if (!/^\d{5}(-\d{4})?$/.test(address.zipcode)) {
    return 'userCard.zipcode.invalid.error';
  }
  return '';
};

const validateEmail = (email) => {
  if (!email) {
    return 'userCard.email.error';
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return 'userCard.email.invalid.error';
  }
  return '';
};

 const validatePhoneNumber = (phone) => {
  if (!phone) {
    return 'userCard.phone.error';
  }
  if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(phone)) {
    return 'userCard.phone.invalid.error';
  }
  return '';
};

 const formatEditablePhoneNumber = (value) => {
   const phoneNumber = value?.replace(/\D/g, '');

   const match = phoneNumber?.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

   if (!match) return value;

   const parts = [match[1], match[2], match[3]].filter(Boolean);

   if (parts.length === 0) return '';
   if (parts.length === 1) return `(${parts[0]}`;
   if (parts.length === 2) return `(${parts[0]}) ${parts[1]}`;
   return `(${parts[0]}) ${parts[1]}-${parts[2]}`;
 };
 const formatZipCode = (zipCode) => {
   const digits = zipCode.replace(/\D/g, '');

   if (digits.length <= 5) {
     return digits;
   }

   return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
 };


 module.exports = { validateAddress, validateEmail,validatePhoneNumber ,formatEditablePhoneNumber,formatZipCode};